import $ from "jquery";

var button = $('.btn');

button.on("mousedown", function(){
    $(this).addClass("onclicked");
}).on("mouseup", function() {
    setTimeout(function() {        
        button.removeClass("onclicked");
    }, 150)
})
